import React from "react";
import ForgotPasswordForm from "~/components/Forms/ForgotPasswordForm";

const ForgotPasswordPage: React.FC = () => {
    return <React.Fragment>
        <ForgotPasswordForm/>
    </React.Fragment>
}

export default ForgotPasswordPage;